import React from 'react';

const ActivitiesConstruction = () => {
  return (
    <section id="activities-construction">

      <h1>Építőipari tevékenység</h1>

      <div id="activities-construction-columns">

        <div id="activities-construction-left">

          <header>

            <div>
              <h2>Üzletágvezető:</h2>
              <ul>
                <li>Ponyokai Bálint</li>
              </ul>
            </div>

            <div>
              <h2>Elérhetőség:</h2>
              <ul>
                <li><a href="tel: +36 70/610-1644">70/610-1644</a></li>
              </ul>
            </div>

          </header>

          <p className="no-indent">
            A Kft. a kezelt ingatlan vagyon karbantartási állagmegőrzési feladatainak elvégzésére rendelkezik építőipari egységgel. 
          </p>
          <p>
            A részleg, kőműves szakmunkásokból, faipari szakemberből, festő, és gépészeti szakemberből áll. A fenti munkák folyamatos szakszerű elvégzéséhez a hiányzó szakmák (villanyszerelő, gázszerelő) pótlásához megfelelő, stabil, megbízható alvállalkozói hátteret sikerült kiépítenünk, melyet a jövőben is fenntartjuk. 
          </p>
          <p>
            A Kft-nk a fenti munkák elvégzéséhez szükséges technikai és eszközháttérrel rendelkezik. 
          </p>
          <p>
            1 db lakatos műhely, melynek felszereltsége a szükséges feladatok ellátásához megfelelő, különböző hegesztő berendezések, különböző megmunkáló kézi szerszámok, illetve nagyobb teljesítményű lemezollók, hajlítók, darabolókkal felszerelt.
          </p>
          <p>
            A faipari részleg is külön műhellyel rendelkezik, melynek felszereltsége az alapvető munkák elvégzésére alkalmas. Mivel a munkák döntő többsége kinti munkaterületen van, ezért fontos ezen részleg kéziszerszám ellátottságának szinten tartása, illetve javítása. 
          </p>
          <p>
          	A műhely kapacitások és lehetőségek teljes kihasználásához bérmunkákat, illetve szolgáltatásokat végzünk. 
          </p>
          <p>
            A klasszikus építő részleg felszereltsége a fenti munkák elvégzéséhez elegendő. A géppark minőségi javítása egy folyamatos feladat. 2020-ban tovább fejlesztjük eszköz és gépparkunkat. 
          </p>
          <p>
          	Az építőipari kapacitás teljes kihasználása érdekében vállalkozási tevékenységet folytatunk.
          </p>

        </div>

        <div id="activities-construction-right">

        </div>

      </div>

    </section>
  );
};

export default ActivitiesConstruction;